<script>
	import { currency_formatter } from '../globals';
	import { onMount } from 'svelte';
	import Header from "../components/Header.svelte";
  import Button, { Label } from '@smui/button/styled';
	import breakpoints from "../utils/breakpoints";
  import Modal from '../utils/Modal.svelte';
	import {
	  api_host,
	  // price_setting_store,
	  user_store,
    domain_code_store
	} from "../stores.js";
	import Loading from '../components/Loading.svelte';
	import { toast_message } from '../utils/toast_message.js';
	import { formatPhoneNumber, getFullState } from '../utils/format.js';
  import { getTax, renderMainServicePriceTable, renderExtraServicePriceTable, getSubtotal, getTotalTax, isNewLayout } from '../utils/tax.js';
	import Swal from "sweetalert2";
	import { navigate } from 'svelte-routing';
  import { doFetch } from '../utils/Fetching.svelte';


	export let params = {};
	const bp = breakpoints();
	let quote = {};
  let quote_slug = null;
	let is_loaded = false;
  let myself = {};
  let domain_code;
  let company_details;

  // photo popup modal
  let modal_photo_popup = false;
  let selected_photo = null;

	user_store.subscribe(value => {
		console.log(value);
	  myself = value;
	});

  domain_code_store.subscribe(value => {
    domain_code = value;
  });

	const refresh_quote = async (slug) => {
	  const res = await doFetch(
      `${api_host}/api/quote/get/slug/${slug}?status=Viewed`, 
      'GET', 
      null, 
      { 'Content-Type': 'application/json', 'DomainCode': domain_code }
    );
	  if (res.status) {
	    quote = res.quote;
      company_details = res.company_details;
      console.log('quote', quote);
	  } else {
	    if (!res.status) {
			  navigate('/');
	    }
	    toast_message(false, res.msg || 'Fetching quote details failed', 3000);
	  }
	  is_loaded = true;
	}

	onMount(async () => {
	  if (params.slug) {
	    quote_slug = params.slug;
	    refresh_quote(quote_slug);
	  }
	});

  const showThumbnail = (photo) => {
      selected_photo = photo;
      modal_photo_popup = true;
  }

  const approve_quote = async () => {
    if (quote.status == 'Approved') return;
    const res = await doFetch(
      `${api_host}/api/quote/get/slug/${quote_slug}?status=Approved`, 
      'GET', 
      null, 
      { 'Content-Type': 'application/json', 'DomainCode': domain_code }
    );
    if (res.status) {
	    quote = res.quote;
      console.log('quote', quote);
      toast_message(true, 'Approved successfully.', 3000);
	  } else {
	    if (!res.status) {
			  // navigate('/');
	    }
	    toast_message(false, res.msg || 'Failed to approve', 3000);
	  }
  };
</script>


<Header />

<div class="contentholder">
  <div class="section clientinfo">
    <div class="sectiontitle"><i class="fas fa-user"></i> Client information</div>

    {#if Object.keys(quote).length}
    <div class="sectioninfo">
        <div class="leftcolumn">
            <div class="infoitem">
                <div class="infoitemtitle">Name:</div>
                <div class="infoitemvalue">{`${quote.first_name} ${quote.last_name}`}</div>
            </div>
            <div class="infoitem">
                <div class="infoitemtitle">Address:</div>
                <div class="infoitemvalue">{`${quote.address}, ${quote.city}, ${getFullState(quote.state)}`}</div>
            </div>
            <div class="infoitem">
                <div class="infoitemtitle">Email:</div>
                <div class="infoitemvalue">{quote.email}</div>
            </div>
        
            <div class="infoitem">
                <div class="infoitemtitle">Home Phone:</div>
                <div class="infoitemvalue">{formatPhoneNumber(quote.home_phone)}</div>
            </div>
        
            <div class="infoitem">
                <div class="infoitemtitle">Cell Phone:</div>
                <div class="infoitemvalue">{formatPhoneNumber(quote.mobile_phone)}</div>
            </div>
        </div>
    </div>
    {/if}
  </div>

  <div class="section serviceinfo">
    <div class="sectiontitle"><i class="fas fa-info-circle"></i> Service Information</div>

    {#if Object.keys(quote).length}
    <div class="sectioninfo">
        <div class="leftcolumn">
            <div class="infoitem">
              <div class="infoitemtitle">Quote Created Date:</div>
              <div class="infoitemvalue">{new Date(quote.created_at).toLocaleDateString()}</div>
            </div>
            <div class="infoitem">
                <div class="infoitemtitle">Service Type:</div>
                <div class="infoitemvalue">{quote.service_type}</div>
            </div>
            <div class="infoitem">
                <div class="infoitemtitle">Service Frequency:</div>
                <div class="infoitemvalue">{quote.service_frequency}</div>
            </div>
            {#if isNewLayout(quote)}
            <div class="infoitem">
                <div class="infoitemtitle">Service Price:</div>
            </div>
            <div class="infoitem service-price">
                {@html renderMainServicePriceTable(quote.service_prices)}
            </div>
            <div class="infoitem">
              <div class="infoitemtitle">Additional Comments:</div>
            </div>
            <div class="infoitem">
              <div class="infoitemvalue"><pre style="white-space: pre-wrap; word-break: auto-phrase;">{quote.additional_comments || 'None'}</pre></div>
            </div>
            <div class="infoitem">
                <div class="infoitemtitle">Extra Service Price:</div>
            </div>
            <div class="infoitem service-price">
                {@html renderExtraServicePriceTable(quote.service_prices)}
            </div>
            <div class="infoitem">
                <div class="infoitemtitle">Subtotal:</div>
                <div class="infoitemvalue">{currency_formatter.format(getSubtotal(quote.service_prices))}</div>
            </div>
            <div class="infoitem">
                <div class="infoitemtitle">Tax:</div>
                <div class="infoitemvalue">{currency_formatter.format(getTotalTax(quote.service_prices))}</div>
            </div>
            {:else}
            <div class="infoitem">
                <div class="infoitemtitle">Service Price:</div>
                <div class="infoitemvalue">{currency_formatter.format(quote.service_price)}</div>
            </div>
            <div class="infoitem">
                <div class="infoitemtitle">Extra Service Price:</div>
                <div class="infoitemvalue">{currency_formatter.format(quote.extra_service_price)}</div>
            </div>
            {/if}
            <div class="infoitem">
                <div class="infoitemtitle">Total Service Price:</div>
                <div class="infoitemvalue">{currency_formatter.format(quote.total_service_price)}</div>
            </div>
            {#if quote.service_frequency !== 'One-Time'}
            <div class="infoitem">
                <div class="infoitemtitle">Next Service Price:</div>
                <div class="infoitemvalue">{currency_formatter.format(parseFloat(quote.next_service_price))}</div>
            </div>
            {/if}
            <!-- <div class="infoitem">
                <div class="infoitemtitle">Service Date:</div>
                <div class="infoitemvalue">{`${formatDate(quote.service_date)} ${quote.time_preference}`}</div>
            </div> -->
            {#if quote.service_type == 'Yard/Lawn Service'}
            <div class="infoitem">
                <div class="infoitemtitle">Lawn:</div>
                <div class="infoitemvalue">{quote.lawn}</div>
            </div>
            {/if}
        </div>
    </div>
    {/if}
  </div>

  {#if (quote.photos ?? []).length > 0}
  <div class="section photoinfo">
      <div class="sectiontitle"><i class="fas fa-info-circle"></i> Photos</div>
      <div class="sectioninfo">
          <div class="photo-list">
              {#each (quote.photos ?? []) as photo}
              <div class="photo-item" on:click="{showThumbnail(photo)}">
                  <img class="photo" src="{photo}" alt="{photo}" />
              </div>
              {/each}
          </div>
      </div>
  </div>
  {/if}

  <Modal bind:modal_show={modal_photo_popup} modal_width={window.innerWidth < 600 ? window.innerWidth - 10 : 600} modal_padding=15>
    <div>
        <div style="padding-bottom: 5px; font-size: 18px; font-weight: 500;">Photo</div>
        <img class="photo-thumbnail" src="{selected_photo}" alt="{selected_photo}" />
    </div>
  </Modal>

  <div class="">
    {#if company_details?.avatar}
    <img src="{company_details?.avatar}" alt="logo" style="height: 40px;" />
    {/if}
    <div>{company_details?.business_name ?? ''}</div>
    <button
        on:click={() => {approve_quote();}}
        variant="raised" 
        class={`approve-button ${quote?.status === 'Approved' ? 'approved' : ''}`}
    >
        {quote?.status == 'Approved' ? 'Approved' : 'Approve'}
    </button>  
  </div>

</div>



<style>
  .contentholder {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-template-rows: auto;
      grid-template-areas: "bh bh bh bh bh bh bh bh bh bh bh bh"
                          "ci ci ci ci ci ci si si si si si si"
                          "co co co co co co co co co co co co"
                          "pi pi pi pi pi pi pi pi pi pi pi pi";
                          
      gap: 15px;
  }
  .infoitem {
      display: flex;
      flex-direction: row;
      max-width: 100%;
  }
  .infoitem .infoitemtitle {
      width: 50%;
      font-weight: bold;
      text-align: left;
      overflow-wrap: break-word;
      word-wrap: break-word;
      hyphens: auto;
  }
  .infoitem .infoitemvalue {
    max-width: 100%;
    text-align: left;
    padding-left: 10px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }
  :global(.progressitem.completed) {
      background-color: #a2cf6e !important;
  }

  :global(.progressitem.completed .progressitemts) {
      color: white !important;
  }
  .clientinfo {
      grid-area: ci;
  }
  .serviceinfo {
      grid-area: si;
  }
  .photoinfo {
      grid-area: co;
  }
  .section {
      border: 1px solid #1769aa;
  }
  .photo-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
  }
  .photo-item {
      display: flex;
      flex-direction: column;
      margin: 10px;
  }
	.photo{
		height: 150px;
		width: 150px;
	}
  .photo-thumbnail {
      height: 100%;
      width: 100%;
      max-height: 600px;
  }
  .approve-button {
    background-color: #00b300;
    color: white;
    padding-left: 15px;
    padding-right: 15px;
  }
  .approve-button.approved {
    color: black !important;
    background: #E8F5E9;
  }
  @media (max-device-width: 1024px), (max-width: 1023px) {
      .contentholder {
          width: 100%;
          max-width: 100vw;
          margin-left: auto;
          margin-right: auto;
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          grid-template-rows: auto;
          grid-template-areas: "bh"
                              "ci"
                              "si"
                              "co"
                              "pi";
          gap: 20px;

      }
      .infoitem {
          width: 100%;
          display: flex;
          flex-direction: row;
      }
      .infoitem .infoitemtitle {
          width: 50%;
          font-weight: bold;
          text-align: left !important;
          overflow-wrap: break-word;
          word-wrap: break-word;
          hyphens: auto;
      }
      .infoitem .infoitemvalue {
          text-align: left;
          margin-left: 10px;
          overflow-wrap: break-word;
          word-wrap: break-word;
          hyphens: auto;
          width: 50%;
      }
  }
</style>